export default __webpack_public_path__ + "static/media/weightlossregime_1.66ada294.jpg";